"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuccessRedirectParams = exports.readsFromParamValues = void 0;
var date_fns_1 = require("date-fns");
var mapping_1 = require("../../../data/mapping");
var params = function (object) {
    return new URLSearchParams(object).toString();
};
var labelMapping = {
    anytime: 'anytimeMeterReading',
    peak: 'peakMeterReading',
    offpeak: 'offpeakMeterReading',
    heating: 'heatingMeterReading',
    eveningandweekend: 'eveningAndWeekendMeterReading',
    solar: 'solarMeterReading',
    shoulder: 'shoulderMeterReading',
    controlledload_1: 'controlledLoad1MeterReading',
    controlledload_2: 'controlledLoad2MeterReading',
    controlledload_3: 'controlledLoad3MeterReading',
    interval: 'intervalMeterReading',
};
var timeOfUseLabelToReadParam = function (label) {
    return labelMapping[label];
};
var readParamToTimeOfUseLabel = function (param) {
    return Object.keys(labelMapping).find(function (key) {
        // Object.keys doesnt preserve this type.
        return labelMapping[key] === param;
    });
};
var formatReads = function (data) {
    if ((0, mapping_1.isSubmitManualMeterReadElecCX)(data)) {
        return data.registers.reduce(function (acc, _a) {
            var _b;
            var timingCategory = _a.timingCategory, value = _a.value;
            return __assign(__assign({}, acc), (_b = {}, _b[timeOfUseLabelToReadParam(timingCategory)] = value, _b));
        }, {});
    }
    return {
        anytimeMeterReading: data.value,
    };
};
var readsFromParamValues = function (values) {
    return Object.keys(values)
        .map(function (param) {
        // Object.keys doesnt preserve this type.
        var value = values[param];
        return value
            ? {
                timeOfUseLabel: readParamToTimeOfUseLabel(param),
                value: value,
            }
            : null;
    })
        // Typescript doesnt update type when filtering out null.
        .filter(Boolean);
};
exports.readsFromParamValues = readsFromParamValues;
var getSuccessRedirectParams = function (_a) {
    var data = _a.data, fuel = _a.fuel, supplyIndex = _a.supplyIndex, isPending = _a.isPending, isOMR = _a.isOMR;
    var readingDate = data.dateTime
        ? (0, date_fns_1.format)(new Date(data.dateTime), 'yyyy-MM-dd')
        : (0, date_fns_1.format)((0, date_fns_1.startOfToday)(), 'yyyy-MM-dd');
    var reads = formatReads(data);
    return params(__assign(__assign(__assign(__assign({ fuel: fuel }, reads), { readingDate: readingDate }), (supplyIndex ? { supplyIndex: supplyIndex } : {})), { // Don't set the param for 0 or undefined.
        isPending: isPending, isOMR: isOMR }));
};
exports.getSuccessRedirectParams = getSuccessRedirectParams;
